import { render, staticRenderFns } from "./MenuAdmin.vue?vue&type=template&id=25de8f34&lang=true"
import script from "./MenuAdmin.vue?vue&type=script&lang=js"
export * from "./MenuAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports